import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { usePopover } from 'src/components/custom-popover';
import { useTable } from 'src/components/table';
import { useDeleteHearingCouncilLinksMutation, useHearingCouncilLinksQuery } from 'src/graphql';
import { useBoolean } from 'src/hooks/use-boolean';
import { default as UseSearch } from 'src/hooks/use-search';
import { useLocales } from 'src/locales';
import { error } from 'src/theme/palette';
import { FinishedCouncilsFormType } from 'src/types/hearing-council';

const useHearingCouncilsLink = () => {
  // #region States and hooks
  const { t } = useLocales();
  const addSessionDialog = useBoolean();
  const deleteDialog = useBoolean();
  const popover = usePopover();
  const queryClient = useQueryClient();
  const { methods, query, handleSearch, setQuery } = UseSearch<FinishedCouncilsFormType>({});
  const table = useTable({ defaultRowsPerPage: 10, defaultCurrentPage: 0 });
  const { hearingCouncilId } = useParams();

  const { data, isLoading } = useHearingCouncilLinksQuery({ hearingCouncilId: hearingCouncilId });

  const { mutate: deleteHearingCouncilLink, isLoading: isDeleting } =
    useDeleteHearingCouncilLinksMutation({
      onSuccess: () => {
        deleteDialog.onFalse();
        queryClient.invalidateQueries({ queryKey: ['HearingCouncilLinks'] });
      },
    });

  // #region Context Menu Items
  const CONTEXT_ITEMS = [
    {
      onClick: deleteDialog.onTrue,
      icon: 'material-symbols:delete-outline',
      color: error.light,
      label: t('tableLabels.delete'),
    },
  ];
  return {
    t,
    data,
    table: table,
    isLoading,
    addSessionDialog,
    handleSearch,
    setQuery,
    query,
    methods,
    popover,
    deleteDialog,
    CONTEXT_ITEMS,
    deleteHearingCouncilLink,
    isDeleting,
  };
};

export default useHearingCouncilsLink;
